import React from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import {
    createStyles, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, Icon,
    IconButton, Input, InputAdornment, InputLabel, makeStyles, MenuItem, Radio, RadioGroup, Select, TextField, Theme, Typography
} from '@material-ui/core';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { InfluencerContext } from '../NewsContext';

import { ClassificationInfluencerModel } from '../../../Models/ClassificationInfluencerModel';
import { HomeContext } from '../../Home/HomeContext';
import { NewsLoadingContext } from '../NewsLoadingContext';
import { InfluencerModel } from '../../../Models/InfluencerModel';

const useStyles = makeStyles((theme: Theme) => createStyles({
    itens: {
        width: '100%',
        color: 'primary',
    },
    itemData: {
        width: '100%',
        color: 'primary',
        paddingBottom: theme.spacing(1.5),

    },
    linkColor: {
        color: '#2C64D0',
        textOverflow: 'ellipsis',
        '&:hover': {
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    },
    editText: {
        textOverflow: 'ellipsis',
    },
    yellowBackground: {
        backgroundColor: theme.palette.warning.light
    },
    outsideGrid: {
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    loading: {
        minHeight: '20vh'
    },
    linksPaperError: {
        padding: theme.spacing(3),
        border: `1px solid ${theme.palette.error.main}`,
    },
    errorText: {
        paddingLeft: theme.spacing(2)
    }
}));

export default function NewsDataQuestions() {
    const classes = useStyles();

    const newsContext = React.useContext(InfluencerContext);
    const newsLoadingContext = React.useContext(NewsLoadingContext);
    const homeContext = React.useContext(HomeContext);

    const handleChangeInput = (prop: any) => (event: React.ChangeEvent<{ value: unknown }>) => {
        const newValue = event.target.value as string;
        if (newsContext.newsCurrentId !== null) {
            const currentQuestions = newsContext.questions[newsContext.newsCurrentId];

            if (Array.isArray(currentQuestions)) {
                const foundIndex = currentQuestions.findIndex(question => question.id == prop);
                if (foundIndex !== -1) {
                    currentQuestions[foundIndex] = {
                        ...currentQuestions[foundIndex],
                        value: newValue
                    };
                    newsContext.setQuestions({ ...newsContext.questions, currentQuestions });
                }
            }
        }
    };

    const handleChangeBoard = (event: React.ChangeEvent<HTMLInputElement | any>) => {
        const updatedStatusClassification = { ...newsContext.statusClassification };
        if (updatedStatusClassification) {
            updatedStatusClassification[newsContext.newsCurrentId!]['statusClassificacao'] = event.target.value;
            return newsContext.setStatusClassification(updatedStatusClassification);
        }
    };

    const handleChange = (prop: keyof InfluencerModel) => (event: React.ChangeEvent<HTMLInputElement> | any) => {

        if(prop == 'statusRevisor'){
            newsContext.setNews({ ...newsContext.news, [prop]: event.target.value});
        }else{
            newsContext.setNews({ ...newsContext.news, [prop]: event});
        }
    };

    const getBoard = () => {
        if (newsContext.newsCurrentId && newsContext.statusClassification[newsContext.newsCurrentId!]) {
            const influencerBoard = newsContext.statusClassification[newsContext.newsCurrentId!];
            return (
                <>
                    <Grid item xs={6}>
                        <Typography variant="subtitle1">Status da Classificação</Typography>
                        <FormControl fullWidth>
                            <Select
                                id="select-board"
                                value={influencerBoard.statusClassificacao}
                                onChange={handleChangeBoard}
                            >
                                <MenuItem value={0}>SELECIONE</MenuItem>
                                {influencerBoard && influencerBoard.map((board: any) => {
                                    return (
                                        <MenuItem value={board.id} key={board.id}>{board.descricao}</MenuItem>
                                    );
                                })

                                }
                            </Select>
                            <FormHelperText style={influencerBoard.statusClassificacao == 0 ? { color: 'red' } : {}}>
                                {influencerBoard.statusClassificacao == 0 ? 'Este campo é obrigatório.' : ''}
                            </FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="subtitle1">Status da Revisão</Typography>
                        <FormControl fullWidth>
                            <Select
                                id="select-board"
                                value={newsContext.news.statusRevisor}
                                onChange={handleChange('statusRevisor')}
                            >
                                <MenuItem value={0}>SELECIONE</MenuItem>
                                {influencerBoard && influencerBoard.map((board: any) => {
                                    return (
                                        <MenuItem value={board.id} key={board.id}>{board.descricao}</MenuItem>
                                    );
                                })

                                }
                            </Select>
                        </FormControl>
                    </Grid>
                </>
            );
        }
    };

    const ValidadeAnalise = () => {
        return (
            <>
                <Grid item xs={6}></Grid>
                <Grid item xs={6}>
                    <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                        <DatePicker
                            id="news-date"
                            variant="inline"
                            defaultValue={newsContext.news.validadeAnalise}
                            inputVariant="outlined"
                            label="Data de Validade"
                            minDate={new Date().toISOString()}
                            onChange={handleChange('validadeAnalise')}
                            InputProps={{
                                readOnly: true,
                            }}
                            format="dd/MM/yyyy"
                            className={classes.itemData}
                            value={newsContext['news'].validadeAnalise ? newsContext['news'].validadeAnalise : new Date().toISOString()} />
                    </MuiPickersUtilsProvider>
                </Grid>
            </>
        );

    };

    const getInputText = () => {
        return (
            newsContext.newsCurrentId &&
            newsContext.questions[newsContext.newsCurrentId]?.map((question: any) => {
                return question.tipo == 1 ?
                    <>
                        <Grid item xs={12}>
                            <TextField
                                id={question.id}
                                value={question.value ? question.value.toString() : ''}
                                onChange={handleChangeInput(question.id)}
                                label={question.description}
                                variant="outlined"
                                className={classes.itens}
                            />
                        </Grid>
                    </>
                    : null;
            })
        );
    };
    const getInputRadio = () => {
        return (
            newsContext.newsCurrentId &&
            newsContext.questions[newsContext.newsCurrentId]?.map((question: any) => {
                return question.tipo == 2 ?
                    <>
                        <Grid item xs={12}>
                            <FormControl required={true} >
                                <FormLabel required={true} id={question.id} >{question.description}</FormLabel>
                                <RadioGroup
                                    aria-required={true}
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    onChange={handleChangeInput(question.id)}
                                    value={question.value ? question.value.toString() : ''}
                                >
                                    <FormControlLabel value="true" control={<Radio required={true} />} label="Sim" />
                                    <FormControlLabel value="false" control={<Radio required={true} />} label="Não" />
                                </RadioGroup>
                                <FormHelperText style={question.value === undefined ? { color: 'red' } : {}}>
                                    {question.value === undefined && 'Este campo é obrigatório.'}
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                    </>
                    : null;
            })
        );
    };
    const getInputSelect = () => {
        return (
            newsContext.newsCurrentId &&
            newsContext.questions[newsContext.newsCurrentId]?.map((question: any) => {
                return question.tipo == 3 && question.description == 'Pilar do NOK' ?
                    <>
                        <Grid item xs={6}>
                            <Typography variant="subtitle1">{question.description}</Typography>
                            <FormControl fullWidth>
                                <Select
                                    id="select-board"
                                    value={question.value ? question.value.toString() : ' '}
                                    onChange={handleChangeInput(question.id)}
                                >
                                    <MenuItem value={' '}>SELECIONE</MenuItem>
                                    <MenuItem value={'DIRETRIZES JURÍDICAS'}>DIRETRIZES JURÍDICAS</MenuItem>
                                    <MenuItem value={'VALORES AMBEV'}>VALORES AMBEV</MenuItem>
                                    <MenuItem value={'FIT COM A MARCA'}>FIT COM A MARCA</MenuItem>
                                    <MenuItem value={'ATIVISMO'}>ATIVISMO</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </>
                    : question.tipo == 3 && question.description == 'Vale para todas as marcas' ?
                        <>
                            <Grid item xs={6}>
                                <Typography variant="subtitle1">{question.description}</Typography>
                                <FormControl fullWidth>
                                    <Select
                                        id="select-board"
                                        value={question.value ? question.value.toString() : ' '}
                                        onChange={handleChangeInput(question.id)}
                                    >
                                        <MenuItem value={' '} >SELECIONE</MenuItem>
                                        <MenuItem value={'SIM'}>SIM</MenuItem>
                                        <MenuItem value={'NÃO'}>NÃO</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </> : null;
            })
        );
    };
    const getInputsQuests = () => {
        if (newsContext.newsCurrentId) {
            const newsQuestions = newsContext.questions[newsContext.newsCurrentId];
            if (Array.isArray(newsQuestions)) {
                return newsQuestions.map((question) => {
                    return (
                        <>
                            <Grid item xs={12}>
                                {question.tipo == 1 ?
                                    <TextField
                                        id={question.id}
                                        value={question.value ? question.value.toString() : ''}
                                        onChange={handleChangeInput(question.id)}
                                        label={question.description}
                                        variant="outlined"
                                        className={classes.itens}
                                        error={!question.value}
                                        helperText={!question.value && 'Campo obrigatório'}
                                    />
                                    :
                                    <FormControl required={true} >
                                        <FormLabel required={true} id={question.id} >{question.description}</FormLabel>
                                        <RadioGroup
                                            aria-required={true}
                                            aria-labelledby="demo-controlled-radio-buttons-group"
                                            name="controlled-radio-buttons-group"
                                            onChange={handleChangeInput(question.id)}
                                            value={question.value ? question.value.toString() : ''}
                                        >
                                            <FormControlLabel value="true" control={<Radio required={true} />} label="Sim" />
                                            <FormControlLabel value="false" control={<Radio required={true} />} label="Não" />
                                        </RadioGroup>
                                        <FormHelperText style={question.value === undefined ? { color: 'red' } : {}}>
                                            {question.value === undefined && 'Este campo é obrigatório.'}
                                        </FormHelperText>
                                    </FormControl>
                                }
                            </Grid>
                        </>
                    );
                });
            }
        }
    };

    return (
        <>
            <Grid>
                <Grid
                    container
                    spacing={3}
                    alignItems="flex-start" >
                    {getInputRadio()}
                    {getInputText()}
                    {getBoard()}
                    {getInputSelect()}
                    {ValidadeAnalise()}
                    {/* {getInputsQuests()} */}
                </Grid>
            </Grid>
        </>
    );
}